require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-a-letter-to-seattles-laid-off-workers.json") })
        }
      }, "path---blog-a-letter-to-seattles-laid-off-workers");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-a-letter-to-seattles-laid-off-workers!./.cache/json/blog-a-letter-to-seattles-laid-off-workers.json
// module id = 578
// module chunks = 231608221292675